/**
 * Applies specific styles to elements with/*** IMPORTS *******************************************************************/

import { getIsSmall, getIsLarge } from "./inc/utilities";
import "./library/madden-parallax-layout-v1.3-min";
import "./library/madden-lazy-load-v1.5-min";
import "../styles/style.scss";
// import "./inc/shrpa.js";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/*** SERVICE WORKER ************************************************************/

if ("serviceWorker" in navigator) {
	navigator.serviceWorker
		.register("/service-worker.js")
		.then((reg) => {
			// registration worked
			console.log("Registration succeeded. Scope is " + reg.scope);
		})
		.catch((error) => {
			// registration failed
			console.log("Registration failed with " + error);
		});
}

(function ($) {
	/*** GLOBAL VARS *****************************************************************/

	let _lazyLoadObject;

	const screenSm = 782;
	const screenMd = 980;
	const screenLg = 1100;
	const screenXl = 1400;

	/*** FUNCTIONS *****************************************************************/

	// Function to apply styles once the elements exist
	// function applySHRPAStyles() {
	// 	// $('.shrpa-content').each(function () {
	// 	// 	if ($(window).width() >= (screenXl+100)) {
	// 	// 		$(this).find('.shrpa-img-wrap').css('height', '117px');
	// 	// 		$(this).css({
	// 	// 			'max-height': '250px',
	// 	// 			'height': 'auto',
	// 	// 			'gap': '0.5rem'
	// 	// 		});
	// 	// 	} else if ($(window).width() >= screenMd) {
	// 	// 		$(this).find('.shrpa-img-wrap').css('height', '220px');
	// 	// 		$(this).css({
	// 	// 			'max-height': '470px',
	// 	// 			'height': 'auto',
	// 	// 			'gap': '0.5rem'
	// 	// 		});
	// 	// 	} else {
	// 	// 		$(this).find('.shrpa-img-wrap').css({
	// 	// 			'height': '150px',
	// 	// 			'max-height': 'min(40svh, 330px)',
	// 	// 			'overflow': 'hidden',
	// 	// 			'flex': '0 1 45%',
	// 	// 		});
	// 	// 		$(this).find('.shrpa-img-wrap img').css({
	// 	// 			'position': 'relative',
	// 	// 			'left': '50%',
	// 	// 			'top': '0',
	// 	// 			'transform': 'translate(-50%, 0)'
	// 	// 		});
	// 	// 		$(this).css({
	// 	// 			'max-height': '330px',
	// 	// 			'height': 'auto',
	// 	// 			'gap': '0.5rem',
	// 	// 			'justify-content': 'center'
	// 	// 		});
	// 	// 	}
	// 	// 	$(this).find('.shrpa-img').css('height', '100%');
	// 	// });
	// }

	/*** THEME FRAMEWORK FUNCTIONS *************************************************/

	
	/**
	 * Adjusts the top position of the main navigation based on the height of the banner ticker.
	 */
	function adjustNavTop() {
		$('.close-ticker').on('click', function () {
			adjustNavTop();
		});
		const bannerHeight = $('.madden-banners-ticker').outerHeight() || 0;
		$('#main-nav').css('top', bannerHeight + 'px');
	}

	/**
	 * Fires on initial document load
	 */
	const $mobileMenu = $(".wp-block-madden-blocks-mega-menu--mobile-menu");
	let mobileMenuTimer = null;
	const mobileMenuTimerDelay = 500;

	$(".open-search-popup").on("click", function (e) {
		if (window.innerWidth < 768) {
			const $menuClass = '.wp-block-madden-blocks-mega-menu--mobile-menu';
			mobileMenuShow();
			const $searchInput = $("#wp-block-search__input-2");
			if ($searchInput.length) {
				$searchInput.focus();
			}
		}
	});

	/**
	 * Show the mobile menu
	 */
	function mobileMenuShow() {

		const header = document.querySelector(".wp-block-template-part");
		const headerHeight = header.getBoundingClientRect().height;

		$(".menu-icon").addClass("active");
		$mobileMenu.addClass("active visible");

		$("body").addClass("no-scroll");
		$mobileMenu.css("height", "calc(100dvh - " + headerHeight + "px)");

		clearTimeout(mobileMenuTimer);
	}

	/**
	 * Hide the mobile menu
	 */
	function mobileMenuHide() {

		$(".menu-icon").removeClass("active");
		$mobileMenu.removeClass("visible");

		$("body").removeClass("no-scroll");
		$mobileMenu.css("height", "auto");

		mobileMenuTimer = setTimeout(() => {
			clearTimeout(mobileMenuTimer);
			$mobileMenu.removeClass("active");
		}, mobileMenuTimerDelay);
	}

	/**
	 * Fires on initial document load
	 */
	function themeOnLoad() {
		// Initialize Fancybox for elements with [data-fancybox] attribute
		Fancybox.bind("[data-fancybox]", {
			closeButton: true,
			Toolbar: {
				enabled: false,
			},
			wheel: false,
		});

		// SHRPA

		/*
		Mobile menu submenu toggles
		*/

		const navItemsWithHover = document.querySelectorAll(
			".wp-block-navigation-item.has-child[data-wp-on-async--mouseenter]"
		);

		navItemsWithHover.forEach((item) => {
			// Remove all WordPress async interaction attributes to disable hover effects
			item.removeAttribute("data-wp-on-async--mouseenter");
			item.removeAttribute("data-wp-on-async--mouseleave");
			item.removeAttribute("data-wp-on--focusout");
			item.removeAttribute("data-wp-on--keydown");
			item.removeAttribute("data-wp-interactive");
			item.removeAttribute("data-wp-watch");
			item.removeAttribute("data-wp-context");

			// Remove any hover-related class that might enable unwanted behavior
			item.classList.remove("open-on-hover-click");

			// Add a single click listener to the parent navigation item.
			// This ensures that only actual links or submenu toggles trigger actions,
			// preventing unwanted behavior when clicking empty space within the item.
			item.addEventListener("click", (e) => {
				const clickedElement = e.target;
				const isLink = clickedElement.closest("a"); // Check if the clicked element or its ancestor is a link
				const isSubmenuToggle = clickedElement.closest(
					".wp-block-navigation-submenu__toggle"
				); // Check if it's a submenu toggle

				// If the click is NOT on a link AND NOT on a submenu toggle,
				// prevent its default action and stop event propagation.
				if (!isLink && !isSubmenuToggle) {
					e.preventDefault();
					e.stopPropagation();
				}
			});
		});

		// Select all submenu toggle buttons
		const submenuToggles = document.querySelectorAll(
			".wp-block-navigation-submenu__toggle"
		);

		// Check if any submenu toggles exist before proceeding
		if (submenuToggles.length > 0) {
			// Iterate over each submenu toggle
			submenuToggles.forEach((toggle) => {
				// Add a click event listener to each toggle
				toggle.addEventListener("click", () => {
					// Toggle the 'open-submenu' class on the clicked toggle button itself
					toggle.classList.toggle("open-submenu");

					// Get the next sibling element, which should be the submenu
					const submenu = toggle.nextElementSibling;

					// Ensure the next sibling exists and is a submenu
					if (
						submenu &&
						submenu.classList.contains("wp-block-navigation-submenu")
					) {
						if (toggle.classList.contains("open-submenu")) {
							// When the submenu is opening:
							// Add the 'submenu-is-open' class to the submenu for styling
							submenu.classList.add("submenu-is-open");

							// 1. Temporarily set height to 'auto' to calculate its natural height
							submenu.style.height = "auto";
							const submenuHeight = submenu.getBoundingClientRect().height;
							// 2. Reset height to 0 to prepare for animation start
							submenu.style.height = "0";

							// 3. Animate height to the calculated height for a smooth slide-down effect
							setTimeout(() => {
								submenu.style.height = `${submenuHeight}px`;
							}, 0);

							// 4. Slightly delay opacity animation for a phased reveal
							setTimeout(() => {
								submenu.style.opacity = 1;
							}, 100);

							// 5. After animation, set height to 'auto' for responsiveness
							// and ensure full visibility and interactivity.
							setTimeout(() => {
								submenu.style.height = "auto";
								submenu.style.opacity = 1;
								submenu.style.visibility = "visible"; // Explicitly ensure visibility
							}, 100);

							// 6. Get submenu items and apply a staggered fade-in animation
							const items = submenu.querySelectorAll(
								".wp-block-navigation-item"
							);
							items.forEach((item, index) => {
								item.style.animation = `fadeIn 0.2s ease forwards ${
									index * 0.0125
								}s`;
							});
						} else {
							// When the submenu is closing:
							// Remove the 'submenu-is-open' class from the submenu
							submenu.classList.remove("submenu-is-open");

							// 1. Immediately set height, opacity, and visibility to hide it
							submenu.style.height = "0";
							submenu.style.opacity = 0;
							submenu.style.visibility = "hidden"; // Explicitly hide

							// 2. Get submenu items and immediately hide them, resetting any animations
							const items = submenu.querySelectorAll(
								".wp-block-navigation-item"
							);
							items.forEach((item) => {
								item.style.opacity = "0";
								item.style.animation = ""; // Reset any existing animations
							});
						}
					}
				});
			});
		}

		// SHRPA SIZING

		// Run the function in case elements are already there
		// applySHRPAStyles();

		// Set up a MutationObserver to watch for dynamically added elements
		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				mutation.addedNodes.forEach(function (node) {
					if ($(node).hasClass('shrpa-content') || $(node).find('.shrpa-content').length) {
						// applySHRPAStyles(); // Apply styles when new elements are added
						const btn = document.querySelector('.shrpa-show-all-btn');
						btn.classList.add("d-block");
						const handler = () => {
							btn.classList.remove("d-block")
							btn.removeEventListener("click", handler);
						}	
						btn.addEventListener("click", handler);
					}
				});
			});
		});

		// Observe the body for added nodes
		observer.observe(document.body, { childList: true, subtree: true });

		/**
		 * Mobile menu toggle
		 */
		$(".menu-icon").on("click", function () {
			if ($(this).hasClass("active")) {
				mobileMenuHide();
				$(this).find("text").text("MENU");
			} else {
				mobileMenuShow();
				$(this).find("text").text("CLOSE");
			}
		});
	}
	/**
	 * Fires on load and scroll
	 */
	function themeOnScroll() {
		var scroll = $(window).scrollTop();
		if (scroll > 100) {
			$("body").addClass("site-scrolled");
		} else {
			$("body").removeClass("site-scrolled");
		}
	}

	/**
	 * Fires on load and window resize
	 */
	function themeOnResize() {
		// Lazy load
		if ($("*[data-load-type]").length) {
			_lazyLoadObject = MMLazyLoad.init({
				loadElements: document.querySelectorAll("[data-load-type]"),
			});
		}

		// parallax
		const parallaxEls = $(".has-parallax");
		if (parallaxEls.length && getIsLarge()) {
			parallaxEls.each((i, el) => {
				$(el).parallaxBG({
					adjustY: 0.12,
					bgXPosition: "center",
					bgYPosition: "center",
				});
			});
		}


		//SHRPA RESIZING
		// applySHRPAStyles();

		// Banner Resizing
		adjustNavTop();


		// Mobile Menu
		mobileMenuHide();
	}

	$(document).ready(function ($) {
		//loadWeather();

		// Header slide up/down on scroll
		let lastScrollTop = 0;
		const header = $("#main-nav");
		const headerHeight = header.outerHeight(); // Get the initial height of the header

		// Wait until adjustNavTop is finished before attaching scroll event
		Promise.resolve().then(() => {
			adjustNavTop();

			let isScrolling;
			$(window).on("scroll", function () {
				const currentScrollTop = $(this).scrollTop();

				if (currentScrollTop > 100) {
					clearTimeout(isScrolling);
					if (currentScrollTop > lastScrollTop) {
						// Scrolling down, tuck the header up
						header.stop().animate({ top: -headerHeight }, 300); // Animate to hide it above the viewport
					} else {
						// Scrolling up, bring the header down
						isScrolling = setTimeout(() => {
							header.stop().animate({ top: 0 }, 300); // Animate back to its original position
						}, 100); // Debounce to prevent glitchy animation
					}
				} else {
					// Near the top, ensure header is visible
					header.stop().animate({ top: 0 }, 300);
				}

				lastScrollTop = currentScrollTop;
			});
		});


		/*** EVENT LISTENERS **************************************************************/
		themeOnLoad();

		themeOnScroll();
		$(window).scroll(themeOnScroll);
		let lastFunctionFired = null;
		$(window).on('scroll wheel keydown', (e) => {
			const scroll = window.scrollY;
			const $widget = $('#visit_widget_button');
			const footerOffsetTop = $('footer').offset().top;

			// Define your functions
			const hideWidget = () => {
				$widget.animate({ opacity: 0 }, "100ms");
				$widget.css({ pointerEvents: "none" });
			};

			const showWidget = () => {
				$widget.animate({ opacity: 1 }, "300ms");
				$widget.css({ pointerEvents: "auto" });
			};

			const animateWidget = (fn, functionName) => {
				if (e.type === "keydown" && e.key === "ArrowDown" && (e.metaKey || e.ctrlKey)) {
				    animateWidget(hideWidget, 'hideWidget');
				    return;
				} 
				// If the same function was fired last, return early
				if (lastFunctionFired === functionName) {
					return;
				}

				fn(); // Execute the provided function
				lastFunctionFired = functionName; // Update the last function fired
			};

			// Determine which function to fire based on the scroll threshold
			if ((scroll + window.innerHeight) > footerOffsetTop) {
				animateWidget(hideWidget, 'hideWidget');
			} else {
				animateWidget(showWidget, 'showWidget');
			}
		});

		themeOnResize();
		$(window).resize(themeOnResize);
	});
})(jQuery);
